import { createSlice } from '@reduxjs/toolkit';
import { type TextMessage } from '@reliance/types/models/TextMessage';
import { type EventListenerState } from '../../types/store/states/EventListenerState';
import { resetUnreadTexts } from '../actions/eventListener';

type TextMessageServerEvent = {
  data: TextMessageRelay;
  type: 'reliancetelephone.connect.text-message/persist' | string;
};

type TextMessageRelay = TextMessage & {
  facility: string | { name?: string };
  inmateName: string;
};

const initialState: EventListenerState = {
  unreadTexts: 0,
};

export const eventListener = createSlice({
  name: 'eventListener',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(resetUnreadTexts, (state, _action) => {
        state.unreadTexts = 0;
      })
      .addMatcher(
        (action) =>
          action.type === 'reliancetelephone.connect.text-message/persist',
        (state, _action: TextMessageServerEvent) => {
          state.unreadTexts++;
        },
      );
  },
  reducers: {},
});

export default eventListener.reducer;
